import type { LabelId, MailboxId, MessageId, SystemFolder } from "@mailflare/shared";

/** Canonical in-app URLs. Every link in the UI is generated here (no dead links). */
export const routes = {
  login: "/login",
  signup: "/signup",
  loginTotp: "/login/totp",
  settings: "/settings",
  admin: "/admin",
  root: "/",
  folder: (mailboxId: MailboxId, folder: SystemFolder) => `/mail/${mailboxId}/folder/${folder}`,
  starred: (mailboxId: MailboxId) => `/mail/${mailboxId}/starred`,
  label: (mailboxId: MailboxId, labelId: LabelId) => `/mail/${mailboxId}/label/${labelId}`,
  search: (mailboxId: MailboxId, query?: string) => {
    const base = `/mail/${mailboxId}/search`;
    return query !== undefined && query.length > 0
      ? `${base}?q=${encodeURIComponent(query)}`
      : base;
  },
  message: (pathname: string, messageId: MessageId) => `${pathname}?message=${messageId}`,
  inbox: (mailboxId: MailboxId) => `/mail/${mailboxId}/folder/inbox`,
} as const;
